import { makeStyles } from '@material-ui/core';
import { indents } from 'Components/uiKitElems';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    height: 'calc(100% - 120px)',
  },
  tableWrapper: {
    marginTop: indents.thirtyTwo,
  },
  noDataNotice: {
    position: 'absolute',
    top: '50%',
    left: '40%',
  },
  tableRowActions: {
    width: 'fit-content',
    display: 'flex',
  },
  actionsRow: {
    marginTop: indents.thirtyTwo,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
}));

export default useStyles;
